import React, { useEffect, useState } from 'react';
import { ContentCarrier } from "models";
import KidsCard from './KidsCard';
import { MediaCategory, MediaItem } from './interfaces';
import e from 'express';
import { formatPlayTime } from './utils';
import './MainContent.scss';
import { usePlaywatchKids } from './Context';
import { get_all_profile, get_selected_profile, setSelectedprofile } from 'features/profile/profile-slice';
import * as applicationSlice from 'features/application/application-slice'
import { useDispatch, useSelector } from 'react-redux';
import * as localStorageService from 'components/localStorageService'
import { ResourcePropertyType } from 'features/enumerations';
import SubscribePanel from './SubscribePanel';

export default function PlaywatchMainContent({ contentCarrier }: { contentCarrier: ContentCarrier }) {
    const [media, setMedia] = useState([]);
    let dispatch = useDispatch()
    const { selectedCategory, searchTerm, setSelectedMedia, } = usePlaywatchKids()
    let profile_list = useSelector(get_all_profile)
    let selected_profile = useSelector(get_selected_profile);
    let claims = useSelector(applicationSlice.getUserClaims);
    useEffect(() => {
        let temp = [];
        if (searchTerm) {
            let tempTerm = `${searchTerm}`.toLowerCase();
            contentCarrier?.media?.categories.map((x: MediaCategory) => {
                temp.push(...x.media.filter((media: MediaItem) => {
                    return `${media?.description} ${media?.name} ${x?.name}`.toLowerCase().indexOf(tempTerm) !== -1;
                }))
            })
        }
        else {
            contentCarrier?.media?.categories.filter(x => {
                if (selectedCategory)
                    return x.listId === selectedCategory
                return true;
            }).map(x => temp.push(...x.media));
        }
        setMedia(temp);
    }, [contentCarrier, selectedCategory, searchTerm]);

    useEffect(() => {
        if (!selected_profile && profile_list?.length) {
            try {
                let p = profile_list[0];
                try {
                    let data = localStorageService.load('ProfileId');
                    if (data) {
                        p = profile_list.find(x => `${x.id}` === `${data.profileId}`)
                    }
                } catch (e) {
                    console.error(e);
                }

                localStorageService.store(
                    {
                        profileId: p?.id,
                        date: Date.now(),
                    },
                    'ProfileId',
                )
                dispatch(setSelectedprofile(p.id))
                dispatch(applicationSlice.setProfileImage(p.profileImage))
                dispatch(applicationSlice.setProfileName(p.name))
            } catch (e) { }
        }

    }, [selected_profile, profile_list?.length])
    if (!media?.length) {
        return <></>
    }
    return (
        <>
            <MediaGrid onMediaStart={(media) => {
                setSelectedMedia(media);
            }} media={media} />
        </>
    )
}

interface MediaGridProps {
    media: MediaItem[];
    onMediaStart: (media: MediaItem) => void
}

const MediaGrid: React.FC<MediaGridProps> = ({ onMediaStart, media }) => {
    const claims = useSelector(applicationSlice.getUserClaims);
    return (
        <div className="media-grid">
            {
                media.map((item, index) => {
                    let thumbNameState = item.states.find(x => x.resourcePropertyType === ResourcePropertyType.Thumbnail)
                    let gifState = item.states.find(x => x.resourcePropertyType === ResourcePropertyType.GifPreview)
                    return (
                        <KidsCard key={index}
                            thumbnailUrl={thumbNameState?.url}
                            duration={`${formatPlayTime(item.duration)}`}
                            gifUrl={gifState?.url || thumbNameState?.url}
                            title={item.name}
                            onClick={() => {
                                if (claims?.subscription) {
                                    onMediaStart(item);
                                }
                            }}
                            description={item.description || 'This is a description to test stuff, and some more words that will make the text too long.'} />
                    )
                })
            }
        </div>
    )
};